import moment from 'moment'

export const plant = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}